import React from "react";
import { VMBuilder } from "../../../../commons/base/providers/builder";
import StringUtils from "../../../../commons/utils/string_utils";
import AdjustmentFormsProductionViewModel from "../view_models/adjustment_forms_production_view_model";

export default class AdjustmentFormsProductionTableWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<AdjustmentFormsProductionViewModel>>
                {(vm) => (
                    <div className="overflow-x-auto">
                        <table className="table-fixed min-w-full border-collapse text-center">
                            <thead>
                                <tr className="bg-gray-200">
                                    <th className="p-1.5 border border-gray-300 w-1/2">
                                        Tanggal Produksi
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-1/2">
                                        Nama Responden
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {vm.productionDataList?.map((data, index) => (
                                    <tr
                                        key={index}
                                        className="odd:bg-white even:bg-gray-100 cursor-pointer text-center hover:bg-slate-200"
                                        onClick={() => {
                                            vm.setCurrentEditedProductionData(data);
                                            vm.fetchProductionDetail(data.id);
                                            vm.setFormId(data.id);
                                            vm.setIsShowModal(true);
                                        }}
                                    >
                                        <td className="p-2 border border-gray-300">
                                            {StringUtils.toIndonesianDate(
                                                new Date(
                                                    StringUtils.LocaleToUTC(data.receivedAt)
                                                )
                                            ) ?? " - "}
                                        </td>
                                        <td className="p-2 border border-gray-300">
                                            {data.respondentName ?? " - "}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
